// src/oura/ask/planHref.ts
//
// Ask Oura (PREVIEW): the Page workshop on the page a client's approved
// answers belong to, with them marked (`from=plan`). Its own module so the
// triage, the answers and the Delivery card all link the same way.

import { getBusiness } from "../data";
import { PLAN_PAGE_TITLE, planPageUrl } from "./planProposals";
import { hrefs } from "./text";

export function planPageHref(businessId: string, mark = true): string {
    const domain = getBusiness(businessId)?.domain;
    return domain ? hrefs.page(businessId, planPageUrl(domain), PLAN_PAGE_TITLE, mark) : hrefs.pages(businessId);
}
